import { AbstractReelsProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractReelsProperties";
import { Modules } from "@lib/titan2/dist/game/Constants";
import { HorizontalLayout } from "@lib/titan2/dist/game/control/layout/HorizontalLayout";
import { PanelProperties } from "@lib/titan2/dist/game/control/properties/PanelProperties";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { Point } from "pixi.js";
export class GameReelsProperties extends AbstractReelsProperties {
    equals(other) {
        return this.scale.equals(other.scale) && this.position.equals(other.position) && this.panelProperties.equals(other.panelProperties);
    }
    setDefaultValues() {
        super.setDefaultValues();
        this.scale.set(1);
        this.position = new Point(108, 1316);
        this.panelProperties = new PanelProperties();
        this.panelProperties.position.set(36, 62);
        this.panelProperties.layout = new HorizontalLayout(18);
        this.freeSpinsBackgroundProperties = new SpineProperties("FreeSpinsReel", Modules.GAME, new Point(473, 137));
        this.backgroundProperties = undefined;
        this.backgroundPurchaseProperties = undefined;
    }
}
//# sourceMappingURL=GameReelsProperties.js.map